import { IconProps } from '../icon';

export function DeconnexionIcon(props: IconProps) {
  return (
    <svg
      id="Déconnexion"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="39.96"
      height="40"
      viewBox="0 0 39.96 40"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_327"
            data-name="Rectangle 327"
            width="39.96"
            height="40"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_609" data-name="Groupe 609" clipPath="url(#clipPath)">
        <path
          id="Tracé_246"
          data-name="Tracé 246"
          d="M88.7,19.953c0-3.863.008-7.725,0-11.588a3.914,3.914,0,0,0-4.291-4.286q-9.625-.012-19.25,0a3.973,3.973,0,0,0-4.345,4.35c0,1.184.017,2.368-.006,3.551a1.991,1.991,0,0,1-1.987,2.038,1.909,1.909,0,0,1-1.964-1.942,33.27,33.27,0,0,1,.129-5.5A7.781,7.781,0,0,1,64.746.051c6.7-.061,13.395-.077,20.091,0A7.868,7.868,0,0,1,92.728,8q.1,12.007,0,24.016a7.892,7.892,0,0,1-7.989,7.943q-9.951.09-19.9,0a7.916,7.916,0,0,1-7.992-8.018q-.03-1.915,0-3.831a1.959,1.959,0,0,1,1.982-2.123,2.01,2.01,0,0,1,1.984,2.136c.015,1.246-.007,2.492.006,3.738a3.906,3.906,0,0,0,3.974,4.056q10,.037,20,0a3.805,3.805,0,0,0,3.9-3.907c.031-4.018.009-8.037.009-12.055Z"
          transform="translate(-52.819 0.001)"
          fill="#41B883"
        />
        <path
          id="Tracé_247"
          data-name="Tracé 247"
          d="M18.934,176.764c-.761-.734-1.539-1.452-2.279-2.207a1.989,1.989,0,0,1-.09-2.909,1.962,1.962,0,0,1,2.907.093q2.929,2.884,5.814,5.812a1.959,1.959,0,0,1-.011,2.982q-2.883,2.93-5.814,5.812a1.958,1.958,0,0,1-2.907.073,1.989,1.989,0,0,1,.111-2.909c.741-.751,1.523-1.462,2.287-2.191l-.084-.259H2.976c-.249,0-.5.007-.747,0A2.087,2.087,0,0,1,0,179.032a2.065,2.065,0,0,1,2.245-2.008c4.453-.017,8.906-.007,13.359-.007h3.234l.1-.252"
          transform="translate(0 -159.037)"
          fill="#41B883"
        />
      </g>
    </svg>
  );
}

export default DeconnexionIcon;
